var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8828 12.9024C19.504 14.3349 17.7143 15.3472 14.1347 17.3718C10.6743 19.3289 8.94414 20.3076 7.54981 19.9142C6.97335 19.7515 6.44813 19.4427 6.02454 19.0173C5 17.9881 5 15.9921 5 12C5 8.00789 5 6.01184 6.02454 4.98274C6.44813 4.55728 6.97335 4.24841 7.54981 4.08578C8.94414 3.69243 10.6743 4.67101 14.1347 6.62819C17.7143 8.65276 19.504 9.66506 19.8828 11.0976C20.0391 11.6889 20.0391 12.311 19.8828 12.9024Z",
    fill: "#1E1F26",
    stroke: "#1E1F26",
    strokeWidth: 1.60714,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.8b78d4cdb6a52df2f840aa8f5d50005f.svg";
export { ForwardRef as ReactComponent };